var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{directives:[{name:"dragscroll",rawName:"v-dragscroll"}],staticClass:"coupon-list no-style-list"},_vm._l((_vm.coupons),function(coupon){return _c('li',[_c('Coupon',{key:coupon.id,attrs:{"coupon":coupon},on:{"close-popover":function($event){return _vm.$emit('close-popover')}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }